/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { GetFrontRichiesteIdModuloIdDocumentoConsolidatoParams } from '../schemas/getFrontRichiesteIdModuloIdDocumentoConsolidatoParams.ts';
import type { GetFrontRichiesteIdModuloIdDocumentoPrincipaleParams } from '../schemas/getFrontRichiesteIdModuloIdDocumentoPrincipaleParams.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Permette il download della Richiesta Modulo in pdf
 * @deprecated
 * @summary Download della Richiesta Modulo (pdf)
 */
export const getFrontRichiesteIdModuloIdDocumentoFirma = (
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-firma`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuloIdDocumentoFirmaQueryKey = (
  idRichiesta: string,
  idRichiestaModulo: string,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-firma`,
  ] as const;

export const getGetFrontRichiesteIdModuloIdDocumentoFirmaQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirma>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirma>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirma>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuloIdDocumentoFirmaQueryKey(
      idRichiesta,
      idRichiestaModulo,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirma>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuloIdDocumentoFirma(
      idRichiesta,
      idRichiestaModulo,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idRichiesta && idRichiestaModulo),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuloIdDocumentoFirmaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirma>>
>;
export type GetFrontRichiesteIdModuloIdDocumentoFirmaQueryError =
  ErrorType<unknown>;

/**
 * @deprecated
 * @summary Download della Richiesta Modulo (pdf)
 */
export const useGetFrontRichiesteIdModuloIdDocumentoFirma = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirma>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirma>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdModuloIdDocumentoFirmaQueryOptions(
    idRichiesta,
    idRichiestaModulo,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette il download del pdf firmato
 * @deprecated
 * @summary Download del pdf firmato
 */
export const getFrontRichiesteIdModuloIdDocumento = (
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuloIdDocumentoQueryKey = (
  idRichiesta: string,
  idRichiestaModulo: string,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento`,
  ] as const;

export const getGetFrontRichiesteIdModuloIdDocumentoQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumento>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumento>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumento>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuloIdDocumentoQueryKey(
      idRichiesta,
      idRichiestaModulo,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumento>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuloIdDocumento(
      idRichiesta,
      idRichiestaModulo,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idRichiesta && idRichiestaModulo),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuloIdDocumentoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumento>>
>;
export type GetFrontRichiesteIdModuloIdDocumentoQueryError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Download del pdf firmato
 */
export const useGetFrontRichiesteIdModuloIdDocumento = <
  TData = Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumento>>,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumento>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontRichiesteIdModuloIdDocumentoQueryOptions(
    idRichiesta,
    idRichiestaModulo,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette il download del pdf modulo principale più avanzato (protocollato se c'è, altrimenti firmato, o compilato)
 * @deprecated
 * @summary Download del pdf dell'ultima versione (quella più avanzata) modulo principale (es. protocollato se c'è, altrimenti firmato, o infine compilato)
 */
export const getFrontRichiesteIdModuloIdDocumentoPrincipale = (
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoPrincipaleParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-principale`,
      method: 'get',
      params,
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuloIdDocumentoPrincipaleQueryKey = (
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoPrincipaleParams,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-principale`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdModuloIdDocumentoPrincipaleQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoPrincipale>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoPrincipaleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoPrincipale>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoPrincipale>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuloIdDocumentoPrincipaleQueryKey(
      idRichiesta,
      idRichiestaModulo,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoPrincipale>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuloIdDocumentoPrincipale(
      idRichiesta,
      idRichiestaModulo,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idRichiesta && idRichiestaModulo),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuloIdDocumentoPrincipaleQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoPrincipale>>
  >;
export type GetFrontRichiesteIdModuloIdDocumentoPrincipaleQueryError =
  ErrorType<unknown>;

/**
 * @deprecated
 * @summary Download del pdf dell'ultima versione (quella più avanzata) modulo principale (es. protocollato se c'è, altrimenti firmato, o infine compilato)
 */
export const useGetFrontRichiesteIdModuloIdDocumentoPrincipale = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoPrincipale>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoPrincipaleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoPrincipale>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdModuloIdDocumentoPrincipaleQueryOptions(
      idRichiesta,
      idRichiestaModulo,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Download del Modulo (pdf) generato a runtime. Il file non viene memorizzato
 * @summary Download del Modulo (pdf) generato a runtime. Il file non viene memorizzato.
 */
export const getFrontRichiesteIdModuloIdDocumentoGenerato = (
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-generato`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuloIdDocumentoGeneratoQueryKey = (
  idRichiesta: string,
  idRichiestaModulo: string,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-generato`,
  ] as const;

export const getGetFrontRichiesteIdModuloIdDocumentoGeneratoQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoGenerato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoGenerato>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoGenerato>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuloIdDocumentoGeneratoQueryKey(
      idRichiesta,
      idRichiestaModulo,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoGenerato>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuloIdDocumentoGenerato(
      idRichiesta,
      idRichiestaModulo,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idRichiesta && idRichiestaModulo),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuloIdDocumentoGeneratoQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoGenerato>>
  >;
export type GetFrontRichiesteIdModuloIdDocumentoGeneratoQueryError =
  ErrorType<unknown>;

/**
 * @summary Download del Modulo (pdf) generato a runtime. Il file non viene memorizzato.
 */
export const useGetFrontRichiesteIdModuloIdDocumentoGenerato = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoGenerato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoGenerato>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdModuloIdDocumentoGeneratoQueryOptions(
      idRichiesta,
      idRichiestaModulo,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette il download del pdf firmato se presente, altrimenti restituisce un 404
 * @summary Download del pdf firmato
 */
export const getFrontRichiesteIdModuloIdDocumentoFirmato = (
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-firmato`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuloIdDocumentoFirmatoQueryKey = (
  idRichiesta: string,
  idRichiestaModulo: string,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-firmato`,
  ] as const;

export const getGetFrontRichiesteIdModuloIdDocumentoFirmatoQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirmato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirmato>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirmato>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuloIdDocumentoFirmatoQueryKey(
      idRichiesta,
      idRichiestaModulo,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirmato>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuloIdDocumentoFirmato(
      idRichiesta,
      idRichiestaModulo,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idRichiesta && idRichiestaModulo),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuloIdDocumentoFirmatoQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirmato>>
  >;
export type GetFrontRichiesteIdModuloIdDocumentoFirmatoQueryError =
  ErrorType<unknown>;

/**
 * @summary Download del pdf firmato
 */
export const useGetFrontRichiesteIdModuloIdDocumentoFirmato = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirmato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoFirmato>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdModuloIdDocumentoFirmatoQueryOptions(
      idRichiesta,
      idRichiestaModulo,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette il download del pdf più avanzato della richiestaModulo (protocollato se c'è, altrimenti firmato, o compilato)
 * @summary Download del pdf dell'ultima versione (quella più avanzata) della richiestaModulo (es. protocollato se c'è, altrimenti firmato, o infine compilato)
 */
export const getFrontRichiesteIdModuloIdDocumentoConsolidato = (
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoConsolidatoParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-consolidato`,
      method: 'get',
      params,
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryKey = (
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoConsolidatoParams,
) =>
  [
    `/framework-cmp-domande/richieste/${idRichiesta}/modulo/${idRichiestaModulo}/documento-consolidato`,
    ...(params ? [params] : []),
  ] as const;

export const getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoConsolidatoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryKey(
      idRichiesta,
      idRichiestaModulo,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>>
  > = ({ signal }) =>
    getFrontRichiesteIdModuloIdDocumentoConsolidato(
      idRichiesta,
      idRichiestaModulo,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idRichiesta && idRichiestaModulo),
    ...queryOptions,
  };
};

export type GetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>>
  >;
export type GetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryError =
  ErrorType<unknown>;

/**
 * @summary Download del pdf dell'ultima versione (quella più avanzata) della richiestaModulo (es. protocollato se c'è, altrimenti firmato, o infine compilato)
 */
export const useGetFrontRichiesteIdModuloIdDocumentoConsolidato = <
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  params?: GetFrontRichiesteIdModuloIdDocumentoConsolidatoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryOptions(
      idRichiesta,
      idRichiestaModulo,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
